import React from "react";

const COLORS_HEX = {
  ACTION: "#96B77A",
  REWARD_UNLOCK: "#92937F",
  REWARD_USE: "#92937F",
  CREATION: "#B0B0B0",
  QR_SCAN: "#4A90E2",
  QR_RESCAN: "#7B68EE",
  RECONNECTION: "#F5A623",
  DEPARTURE: "#D0021B",
  BUTTON_CLICK: "#8B5CF6",
};

export default function EventBadge({ type }) {
  const bg = COLORS_HEX[type] || "#B0B0B0";
  const label = type === "ACTION" ? "Actions" : type === "REWARD_UNLOCK" ? "Récompense" : type === "REWARD_USE" ? "Récompense" : type === "CREATION" ? "Création" : type === "QR_SCAN" ? "Scan QR" : type === "QR_RESCAN" ? "Re-scan QR" : type === "RECONNECTION" ? "Reconnexion" : type === "DEPARTURE" ? "Départ" : type === "BUTTON_CLICK" ? "LuniButton" : type;
  return (
    <span className="px-2 py-0.5 rounded text-white text-xs" style={{ backgroundColor: bg }}>
      {label}
    </span>
  );
}
